/* unplugin-vue-components disabled */import script from "./FilePreview.vue?vue&type=script&setup=true&name=FilePreviewDialog&lang=js"
export * from "./FilePreview.vue?vue&type=script&setup=true&name=FilePreviewDialog&lang=js"

import "./FilePreview.vue?vue&type=style&index=0&id=05175aac&lang=scss"

const __exports__ = script;

export default __exports__